// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/contratti?societaId&commessaId&q',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","stato":"string","clienteRagioneSociale":"string","descrizione":"string","dataInizio":"string","dataFine":"string","periodicita":"string","modalitaPagamento":"string","ordineNumero":"string","commessaNumero":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
